import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useTranslation } from "react-i18next";
import { truncate } from "lodash";
import { Link, useLocation, useMatches } from "react-router-dom";

import {
  breadcrumbMatches,
  resolveBreadcrumb,
  resolveRouteTitle,
  useLocalizeRouteTitle,
} from "@/components/layout/route-title";

export const HeaderBreadcrumbs = () => {
  const { t } = useTranslation("common");
  const localizeTitle = useLocalizeRouteTitle();
  const location = useLocation();
  const matches = useMatches();

  const crumbs = breadcrumbMatches(matches);

  const isCompany = location.pathname.startsWith("/company");
  const homeHref = isCompany ? "/company" : "/";
  // Root landing title: "/" → Home, "/company" → Dashboard.
  const rootTitle = isCompany
    ? t("header.breadcrumb_dashboard")
    : t("header.breadcrumb_home");

  return (
    <div className="flex min-w-0 flex-row items-center gap-3">
      {/* Fixed height + vertical centering: keeps the header a constant height
          whether or not a page has breadcrumbs (no layout shift), and centers
          the title on its own when there are none. */}
      <div className="flex h-10 min-w-0 flex-col justify-center">
        <h1
          className="truncate text-xs lg:text-base font-bold text-primary"
          title={localizeTitle(resolveRouteTitle(matches, rootTitle))}
        >
          {localizeTitle(resolveRouteTitle(matches, rootTitle))}
        </h1>

        {crumbs.length > 0 && (
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink
                  asChild
                  className="text-muted-foreground hover:text-foreground text-[11px] lg:text-xs"
                >
                  <Link to={homeHref}>{rootTitle}</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              {crumbs.map((match, index) => {
                const isLast = index === crumbs.length - 1;
                const label = resolveBreadcrumb(match);
                return (
                  <div key={match.id} className="flex items-center">
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                      {isLast ? (
                        <BreadcrumbPage className="text-[11px] lg:text-xs">
                          {truncate(localizeTitle(label), {
                            length: 20,
                            omission: "...",
                          })}
                        </BreadcrumbPage>
                      ) : (
                        <BreadcrumbLink
                          asChild
                          className="text-muted-foreground hover:text-foreground text-[11px] lg:text-xs"
                        >
                          <Link to={match.pathname}>
                            {truncate(localizeTitle(label), {
                              length: 20,
                              omission: "...",
                            })}
                          </Link>
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                  </div>
                );
              })}
            </BreadcrumbList>
          </Breadcrumb>
        )}
      </div>
    </div>
  );
};
